import { memo, useMemo, type FC } from 'react'
import { useParams, usePathname } from 'next/navigation'
import styled from 'styled-components'
import type  { TypeLang, TypeCmsProductCard, TypeCmsAccessoryCard } from '@/schema'
import { Img, Link } from './commons'
import { getImgTransition, getP24_3, mq, vw } from '@/styles'

type Props = {
  data: TypeCmsProductCard | TypeCmsAccessoryCard
  lazyLoad?: boolean
}

const isAccessoryCard = (data: TypeCmsProductCard | TypeCmsAccessoryCard): data is TypeCmsAccessoryCard => {
  return 'model_reference' in data
}

export const CardProduct:FC<Props> = memo(({ data, lazyLoad }) => {
  const { lang }: { lang: TypeLang } = useParams()
  const { name, medium, slug } = data
  const pathname = usePathname()
  const hrefProduct = useMemo(() => pathname.includes('/usa/') ? `/usa/product/${slug?.[lang]}` : `/product/${slug?.[lang]}`, [pathname, slug, lang])

  return (
    <Article>
      <Link href={hrefProduct} rel='bookmark'>
        <div className='media-wrapper'>
          {medium?.image ? <Img className='media' media={medium.image} {...lazyLoad && { lazy: true }} sizes='(max-width: 768px) 80vw, 40vw' /> : <div className='media' />}
        </div>
        <hgroup>
          <h3>{name}</h3>
          {isAccessoryCard(data) && <p>{data.model_reference}</p>}
        </hgroup>
      </Link>
    </Article>
  )
})

const Article = styled.article`
  height: ${vw(242, 'mobile')};

  ${mq.greaterThan('tablet')} {
    height: ${vw(442, 'desktop')};
  }

  ${mq.greaterThan('tablet')} {
    height: ${vw(431, 'desktop')};
  }

  ${mq.greaterThan('tablet')} {
    height: 431px;
  }


  .media-wrapper {
    height: ${vw(214, 'mobile')};
    overflow: hidden;
    width: 100%;

    ${mq.greaterThan('tablet')} {
      height: ${vw(414, 'desktop')};
    }

    ${mq.greaterThan('tablet')} {
      height: ${vw(396, 'desktop')};
    }

    ${mq.greaterThan('tablet')} {
      height: 396px;
    }
  }

  .media {
    ${getImgTransition()}
    background-color: var(--color-img-placeholder);
    height: 100%;
    transition: 800ms transform var(--transition-ease);
    width: 100%;

  }

  a {
    align-items: center;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: flex-start;

    &:hover {
      .media {
        transform: scale(1.1);
      }
    }
  }

  hgroup {
    margin-top: 2px;
  }

  h3 {
    color: var(--color-text);
    ${getP24_3()}
    text-align: center;
    text-transform: lowercase;
    width: 100%;

    &:first-letter {
      text-transform: uppercase;
    }
  }
`